export type SnDrawerMode = 'adaptive' | 'modal' | 'side';
